var r = require("react-hook-form"),
  e = function (e, i, t) {
    if (e && "reportValidity" in e) {
      var a = r.get(t, i);
      e.setCustomValidity(a && a.message || ""), e.reportValidity();
    }
  },
  i = function (r, i) {
    var t = function (t) {
      var a = i.fields[t];
      a && a.ref && "reportValidity" in a.ref ? e(a.ref, t, r) : a.refs && a.refs.forEach(function (i) {
        return e(i, t, r);
      });
    };
    for (var a in i.fields) t(a);
  };
exports.toNestError = function (e, t) {
  t.shouldUseNativeValidation && i(e, t);
  var a = {};
  for (var o in e) {
    var f = r.get(t.fields, o);
    r.set(a, o, Object.assign(e[o], {
      ref: f && f.ref
    }));
  }
  return a;
}, exports.validateFieldsNatively = i;